module.exports = __webpack_public_path__ + "static/media/swipe-1-1.0fe87c5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/swipe-1-1.mp4
// module id = nMa8
// module chunks = 10